import profileSuggestions from './profileSuggestionsActions';
var allActions = {
  profileSuggestions: profileSuggestions
};
export default allActions;